/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CustomSmsApiKeyAuth
 */
export interface CustomSmsApiKeyAuth {
    /**
     * 
     * @type {string}
     * @memberof CustomSmsApiKeyAuth
     */
    headerName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomSmsApiKeyAuth
     */
    headerValuePlain?: string | null;
}

/**
 * Check if a given object implements the CustomSmsApiKeyAuth interface.
 */
export function instanceOfCustomSmsApiKeyAuth(value: object): value is CustomSmsApiKeyAuth {
    return true;
}

export function CustomSmsApiKeyAuthFromJSON(json: any): CustomSmsApiKeyAuth {
    return CustomSmsApiKeyAuthFromJSONTyped(json, false);
}

export function CustomSmsApiKeyAuthFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomSmsApiKeyAuth {
    if (json == null) {
        return json;
    }
    return {
        
        'headerName': json['header_name'] == null ? undefined : json['header_name'],
        'headerValuePlain': json['header_value_plain'] == null ? undefined : json['header_value_plain'],
    };
}

export function CustomSmsApiKeyAuthToJSON(json: any): CustomSmsApiKeyAuth {
    return CustomSmsApiKeyAuthToJSONTyped(json, false);
}

export function CustomSmsApiKeyAuthToJSONTyped(value?: CustomSmsApiKeyAuth | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'header_name': value['headerName'],
        'header_value_plain': value['headerValuePlain'],
    };
}

